<template>
  <div v-if="envName === 'stater'">
    <br/>

    <div class="text" style="display: flex; align-items: flex-start">
      <input
        type="checkbox"
        required
        v-model="ofertaAccepted"
        style="margin-right: 10px; margin-top: 4px; display: inline-block; vertical-align: middle;"
      />
      <a
        :href="ofertaFile"
        target="_blank"
        style="display: inline-block; vertical-align: middle;"
      >
        Я принимаю условия договора оферты
      </a>
    </div>

    <br/>

    <div class="text" style="display: flex; align-items: flex-start">
      <input
        type="checkbox"
        required
        v-model="persDataAccepted"
        style="margin-right: 10px; margin-top: 4px; display: inline-block; vertical-align: middle;"
      />
      <a
        :href="persFile"
        target="_blank"
        style="display: inline-block; vertical-align: middle;"
      >
        Я даю согласие на обработку персональных данных
      </a>
    </div>
  </div>
</template>

<script setup>
import persFile from '@/assets/stater/policy/pers.pdf'
import ofertaFile from '@/assets/stater/policy/oferta.pdf'

// Define two-way bound props using defineModel
const ofertaAccepted = defineModel('ofertaAccepted', {default: true})
const persDataAccepted = defineModel('persDataAccepted', {default: true})


</script>
